import script from "./BaoGiaNhanhView.vue?vue&type=script&setup=true&lang=js"
export * from "./BaoGiaNhanhView.vue?vue&type=script&setup=true&lang=js"

import "./BaoGiaNhanhView.vue?vue&type=style&index=0&id=df46aefa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df46aefa"]])

export default __exports__